import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
    constructor(private router: Router, private auth: AuthService) {}

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        const token = this.auth.getToken();

        if (!token || this.auth.isTokenExpired()) {
            // ✅ Store the event ID before redirecting to login
            this.auth.storeEventRedirectFromUrl();
            // Do NOT call logout() here — it broadcasts a logout flag to all tabs via localStorage,
            // which would log out every open tab even though this is just an unauthenticated new tab.
            return this.router.parseUrl('/auth/login');
        }

        const userRole = this.auth.getUserRole();
        const routeRoles = Array.isArray(route.data['role'])
            ? route.data['role']
            : [route.data['role']];

        if (userRole && routeRoles.includes(userRole)) {
            return true;
        }

        this.auth.logout();
        return this.router.parseUrl('/auth/login');
    }
}